export const getInTouch = {
  title: "Contact Us",
  title2: "Get In Touch",
  paragraph:
    "If you are looking for digital transformation for your company or organization, we can help you. Do not hesitate to contact us to discuss your ideas and projects, and provide you with a budget according to your needs.",
  subtitle: "Ready to build your software?",
};
